module.exports = __webpack_public_path__ + "img/image 43.31c5da53.svg";